import { render, staticRenderFns } from "./filter-review.vue?vue&type=template&id=64cdeff4&scoped=true"
import script from "./filter-review.vue?vue&type=script&lang=js"
export * from "./filter-review.vue?vue&type=script&lang=js"
import style0 from "./filter-review.vue?vue&type=style&index=0&id=64cdeff4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64cdeff4",
  null
  
)

export default component.exports